<!-- Popup thông tin chi tiết CCQ đang giao dịch -->
<div class="modal-content fund-detail-popup">
  <!-- Modal Header -->
  <div class="modal-header">
    <div class="d-flex justify-content-between">
      <div class="d-flex title__group">
        <img [src]="product.owner?.avatarUrl !== null ? product.owner?.avatarUrl : ' '" alt="" height="44" />
        <div class="title__group--detail">
          <div class="d-flex align-items-center" *ngIf="!isDevice && product.name">
            <label>
              <span>{{product.name}} </span>
              <!-- <span *languageCheck="'EN'">{{product.nameEn}} </span> -->

              ({{product.shortName}})</label>
            <label id="label-new-product" class="ml-2" *ngIf="product.isNewProduct">New</label>
          </div>
          <div class="d-flex flex-row" *ngIf="isDevice">
            <label>{{product.shortName}}</label>
            <label id="label-new-product" class="ml-2" *ngIf="product.isNewProduct">New</label>
          </div>
          <span>{{product.owner?.shortName}}</span>
        </div>
      </div>
      <button type="button" class="btn close-btn" (click)="dismiss()" *ngIf="!isDetailFullPage">
        <svg xmlns="http://www.w3.org/2000/svg" width="49" height="46" viewBox="0 0 49 46" fill="none">
          <path d="M30.3473 16.9706L18.2084 28.2843M18.2084 16.9706L30.3473 28.2843" stroke="#1F1F1F" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  </div>

  <!-- Modal body -->
  <div class="modal-body horizon-mobile">
    <div class="row modal-row">
      <div class="col-lg-7 col-sm-12 col-md-12 col-12">
        <div class="flex-between">
          <div class="card">
            <span>{{'Giá gần nhất' | translate}}</span>
            <div class="group-text">
              <label class="price" for="">{{(product.nav) | number}} VND</label>
              <label class="small-des" for="">{{'Cập nhật ngày' | translate}} {{product.extra?.lastNAVDate ?
                (product.extra?.lastNAVDate | date: 'dd/MM/yyyy ')
                : 'N/A'}}
              </label>
            </div>
          </div>
          <button class="btn btn--blue" type="button" (click)="buy()" *ngIf="!isDetailFullPage">{{'Mua' |
            translate}}</button>
        </div>

        <div class="fund__chart">
          <div class="chart-title">
            <h2> {{'BIỂU ĐỒ TĂNG TRƯỞNG NAV' | translate}}</h2>
            <span class="benefit showMobile" [ngClass]="navChange > 0 ? 'up' : navChange === 0 ? 'pledge' : 'down'"
              *ngIf="navChange !== null">
              <span class="up" *ngIf="navChange > 0">+</span>
              {{navChange}}%
            </span>
            <span class=" showMobile" *ngIf="( navChange === null)"><em>--({{'Chưa
                đủ dữ liệu' | translate}})</em></span>
          </div>

          <div class="fund__chart--filter">
            <ul>
              <li>
                <span class="item" (click)="getDataChart('YTD')" [ngClass]="typeDataChart === 'YTD' ? 'active' : ''">
                  YTD
                </span>
              </li>
              <!-- <li>
                <span class="item" (click)="getDataChart('3')" [ngClass]="typeDataChart === '3' ? 'active' : ''">3
                  {{'tháng' | translate}}</span>
              </li> -->
              <li>
                <span class="item" (click)="getDataChart('6')" [ngClass]="typeDataChart === '6' ? 'active' : ''">6
                  {{'tháng' | translate}}</span>
              </li>
              <li>
                <span class="item" (click)="getDataChart('12')" [ngClass]="typeDataChart === '12' ? 'active' : ''">1
                  {{'năms' | translate}}</span>
              </li>
              <li>
                <span class="item" (click)="getDataChart('24')" [ngClass]="typeDataChart === '24' ? 'active' : ''">2
                  {{'năms' | translate}}</span>
              </li>
              <li>
                <span class="item" (click)="getDataChart('36')" [ngClass]="typeDataChart === '36' ? 'active' : ''">3
                  {{'năms' | translate}}</span>
              </li>
              <li>
                <span class="item" (click)="getDataChart('60')" [ngClass]="typeDataChart === '60' ? 'active' : ''">5
                  {{'năms' | translate}}</span>
              </li>
              <li>
                <span class="item" (click)="getDataChart('ALL')" [ngClass]="typeDataChart === 'ALL' ? 'active' : ''">
                  {{'Tất cả' | translate}}
                </span>
              </li>
            </ul>

            <span class="benefit showDesktop" [ngClass]="navChange > 0 ? 'up' : navChange === 0 ? 'pledge' : 'down'"
              *ngIf="navChange !== null">
              <span class="up" *ngIf="navChange > 0">+</span>
              {{ navChange }}%
            </span>
            <span class=" showDesktop" *ngIf="( navChange === null)"><em>--({{'Chưa
                đủ dữ liệu' | translate}})</em></span>
          </div>

          <div class="chart d-flex flex-column">
            <app-ngx-line-chart [chartData]="chartData" *ngIf="chartData.datasets[0]?.data?.length; else noDataChart">
            </app-ngx-line-chart>
            <ng-template #noDataChart>
              <div class="d-flex flex-column align-items-center justify-content-center" style="min-height: 400px">
                <img loading="lazy" width="100" alt="no-data-chart"
                  [src]="'icon/nodata-chart.svg' | image" height="100" />
                <span>{{'Không có dữ liệu biểu đồ' | translate}}</span>
              </div>
            </ng-template>
          </div>
        </div>

        <div class="col-lg-12 col-sm-12 col-md-12 col-12" *ngIf="product.description">
          <label class="pt-3 pb-3">{{product.description}}</label>
        </div>
      </div>

      <div class="col-lg-5 col-sm-12 col-md-12 col-12" *ngIf="isLoad">
        <div class="content-search list-fund" [ngClass]="isDevice ? 'tab-scrollX-mobile' : 'tab-scrollX'">
          <ul class="nav nav-tabs" id="fundTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button (click)="changeTab(TABS.OVERVIEW)" class="nav-link"
                [ngClass]="tab === TABS.OVERVIEW ? 'nav-link-active' : ''" id="general-tab" type="button" role="tab">
                {{'Tổng quan' | translate}}
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button (click)="changeTab(TABS.TOP_HOLDING)" class="nav-link"
                [ngClass]="tab === TABS.TOP_HOLDING ? 'nav-link-active' : ''" id="investment-tab" type="button"
                role="tab">
                {{'Danh mục đầu tư lớn' | translate}}
              </button>
            </li>
            <li class="nav-item" role="presentation" *ngIf="!isBond">
              <button (click)="changeTab(TABS.INDUSTRY_DISTRIBUTION)" class="nav-link"
                [ngClass]="tab === TABS.INDUSTRY_DISTRIBUTION ? 'nav-link-active' : ''" id="distribution-major-tab"
                type="button" role="tab">
                {{'Phân bổ theo ngành' | translate}}
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button (click)="changeTab(TABS.ASSET_DISTRIBUTION)" class="nav-link"
                [ngClass]="tab === TABS.ASSET_DISTRIBUTION ? 'nav-link-active' : ''" id="distribution-asset-tab"
                type="button" role="tab">
                {{'Phân bổ theo tài sản' | translate}}
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button (click)="changeTab(TABS.DOCUMENTS)" class="nav-link"
                [ngClass]="tab === TABS.DOCUMENTS ? 'nav-link-active' : ''" id="docs-tab" type="button" role="tab">
                {{'Tài liệu quỹ' | translate}}
              </button>
            </li>
          </ul>
          <div class="tab-content" id="fundTabContent">
            <div *ngIf="tab === TABS.OVERVIEW">
              <overview-product [product]="product"></overview-product>
            </div>
            <div *ngIf="tab === TABS.TOP_HOLDING">
              <top-holding-fund [topHolding]="product.productTopHoldingList"
                [updateTime]="product.productFund?.updateAssetHoldingTime"
                [bondList]="product.productTopHoldingBondList">
              </top-holding-fund>
            </div>
            <div *ngIf="tab === TABS.INDUSTRY_DISTRIBUTION">
              <industry-distribution *ngIf="tab === TABS.INDUSTRY_DISTRIBUTION"
                [updateTime]="product.productFund?.updateAssetHoldingTime"
                [industryDistribution]="product.productIndustriesHoldingList">
              </industry-distribution>
            </div>
            <div *ngIf="tab === TABS.ASSET_DISTRIBUTION">
              <asset-distribution *ngIf="tab === TABS.ASSET_DISTRIBUTION"
                [assetDistribution]="product.productAssetHoldingList"
                [updateTime]="product.productFund?.updateAssetHoldingTime">
              </asset-distribution>
            </div>
            <div *ngIf="tab === TABS.DOCUMENTS">
              <documents-fund [documents]="product.productDocuments"> </documents-fund>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>